import { useParams } from 'react-router-dom';

type DisclosureUrl = {
  disclosureId: string;
};

const useDisclosureId = () => {
  const params = useParams<DisclosureUrl>();
  return Number(params.disclosureId);
};

export { useDisclosureId };
